import VGoogle from '@/directives/v-google';

export default {
  VGoogle,
};
